import React from 'react';
import PropTypes from 'prop-types';
import { XTitle } from '@/components/xqxc_ui';
import { Tag, Input, Button, Divider, InputNumber, message } from 'antd';
import { TweenOneGroup } from 'rc-tween-one';
import { FormOutlined } from '@ant-design/icons';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import arrayMove from 'array-move';
import styles from './EditableTagGroup.module.scss';
import { ArticleCategory as ac } from '../types';
import { isNumber } from 'ts-toolset/dist/common/types';

const SortableItem = SortableElement(({ value, onClose, closable }) => (
    <span className={styles.dragItem} key={value} style={{ display: 'inline-block', cursor: 'grab' }}>
        <Tag
            closable={closable}
            onClose={e => {
                e.preventDefault();
                onClose && onClose(value);
            }}
        >{value}</Tag>
    </span>
));

const SortableList = SortableContainer(({ items, onClose, closable, fixedTags }) => {
    return (
        <TweenOneGroup
            enter={{
                scale: 0.8,
                opacity: 0,
                type: 'from',
                duration: 100,
                onComplete: e => {
                    e.target.style = '';
                },
            }}
            leave={{ opacity: 0, width: 0, scale: 0, duration: 200 }}
            appear={false}
        >
            {items.map((value, index) => <SortableItem key={`item-${value}`.replace(/ /g, '')} index={index} value={value} onClose={onClose} closable={closable && !fixedTags.includes(value)} />)}
        </TweenOneGroup>
    );
});

class EditableTagGroup extends React.Component {

    state = {
        tags: [],
        inputValue: '',

        weightBegin: undefined,
        weightEnd: undefined,

        editing: false,
        disabled: true
    };

    originTags = []

    static getDerivedStateFromProps(props, state) {
        if (props.visible === false || state.tags.length === 0) {
            let changes = { tags: props.data };
            if (props.category === ac.WEIGHT) {
                changes.weightBegin = props.data[0];
                changes.weightEnd = props.data[1];
            }
            return changes;
        }
        return null;
    }

    enterEdit = async () => {
        this.props.onEnterEdit && this.props.onEnterEdit(this.props.categoryName);
    }

    handleClose = removedTag => {
        const tags = this.state.tags.filter(tag => tag !== removedTag);
        this.setState({ tags });
    }

    showInput = () => {
        this.setState({ visible: true }, () => this.input.focus());
    }

    handleInputChange = e => {
        this.setState({ inputValue: e.target.value, disabled: !e.target.value });
    }

    handleInputConfirm = () => {
        let { inputValue, weightBegin, weightEnd, tags } = this.state;
        const { category } = this.props;

        let value = inputValue;
        if (category === ac.WEIGHT) {
            isNumber(weightBegin) && (tags[0] = weightBegin);
            isNumber(weightEnd) && (tags[1] = weightEnd);
            tags = [...tags];
        } else {

            let errMsg = false;

            !value && (errMsg = '请输入标签');

            if (category === ac.CATEGORY) {
                tags.includes(value) && (errMsg = '品类标签已存在，请勿重复添加');
                tags.length > 8 && (errMsg = '最多只可添加9个品类标签（包含其他）');
            }

            if (category === ac.PRICE) {
                tags.includes(value) && (errMsg = '价值标签已存在，请勿重复添加');
                tags.length > 8 && (errMsg = '最多只可添加9个价值标签');
            }

            if (category === ac.HELP_BUG_REMAEK) {
                tags.includes(value) && (errMsg = '备注标签已存在，请勿重复添加');
                tags.length > 14 && (errMsg = '最多只可添加15个备注标签');
            }

            if (errMsg) {
                return message.warning(errMsg);
            }

            tags = [value, ...tags];
        }

        this.setState({ tags, inputValue: '', weightBegin: undefined, weightEnd: undefined, disabled: true });
    }

    onSave = () => {

        if (this.props.category === ac.WEIGHT) {
            this.handleInputConfirm();
        }

        let value = this.state.tags.concat();
        this.onLeaveEdit(value);
    }

    onCancel = () => {
        let value = this.props.data.concat();
        this.setState({ tags: value, disabled: true });
        this.onLeaveEdit();
    }

    onLeaveEdit(value) {
        this.setState({ inputValue: '', weightBegin: undefined, weightEnd: undefined });
        this.props.onLeaveEdit && this.props.onLeaveEdit(this.props.id, this.props.category, value);
    }

    saveInputRef = input => {
        this.input = input;
    }

    onSortEnd = ({ oldIndex, newIndex }) => {
        this.setState(({ tags }) => ({ tags: arrayMove(tags, oldIndex, newIndex) }));
    }

    onWweightChange = (value, type) => {
        let { weightBegin, weightEnd } = this.state;

        weightBegin = parseInt(weightBegin);
        weightEnd = parseInt(weightEnd);

        let currentWeight = parseInt(value) || undefined;

        if (isNumber(weightBegin) && isNumber(weightEnd) && isNumber(currentWeight)) {
            if (type === 'weightBegin' && currentWeight >= weightEnd) {
                currentWeight = weightEnd - 1;
            }
            if (type === 'weightEnd' && weightBegin >= currentWeight) {
                currentWeight = weightBegin + 1;
            }
        }

        this.setState({ [type]: currentWeight });
    }

    render() {

        const { tags, inputValue, weightBegin, weightEnd, disabled } = this.state;
        const { category, categoryName, visible, fixedTags = [], inputProps } = this.props;

        return (
            <>
                <XTitle label={categoryName} />
                {!visible &&
                    <span
                        style={{ float: 'right', marginTop: -20, cursor: 'pointer' }}
                        onClick={this.enterEdit}
                    >
                        <FormOutlined /> 编辑
                    </span>
                }
                <Divider style={{ margin: '5px 0' }} />

                {visible &&
                    <div>

                        {category !== ac.WEIGHT &&
                            <Input
                                maxLength={15}
                                type="text"
                                {...inputProps}
                                ref={this.saveInputRef}
                                size="small"
                                style={{ width: 300, marginBottom: 9, marginRight: 10 }}
                                value={inputValue}
                                onChange={this.handleInputChange}
                            />
                        }
                        {category === ac.WEIGHT &&
                            <span style={{ display: 'inline-block', marginBottom: 9, marginRight: 10 }}>
                                <span>最小 <InputNumber size='small' min={1} max={499} value={weightBegin} onChange={(weightBegin) => this.onWweightChange(weightBegin, 'weightBegin')} onBlur={(weightBegin) => this.onWweightChange(weightBegin.target.value, 'weightBegin')} /> kg</span>
                                <span> ~ </span>
                                <span style={{ marginRight: 10 }}>最大 <InputNumber size='small' min={2} max={500} value={weightEnd} onChange={(weightEnd) => this.onWweightChange(weightEnd, 'weightEnd')} onBlur={(weightEnd) => this.onWweightChange(weightEnd.target.value, 'weightEnd')} /> kg</span>
                            </span>
                        }
                        {category !== ac.WEIGHT && <Button type='primary' size='small' onClick={this.handleInputConfirm} style={{ marginRight: 50 }} disabled={disabled}>添加</Button>}
                        <Button type='primary' size='small' style={{ marginRight: 10 }} onClick={this.onSave}>保存</Button>
                        <Button size='small' onClick={this.onCancel}>取消</Button>
                    </div>
                }
                <div style={{ marginBottom: 16, ...(!visible ? { pointerEvents: 'none' } : {}) }} >
                    {category !== ac.WEIGHT &&
                        <SortableList axis='x' lockAxis='x' items={tags} onSortEnd={this.onSortEnd} onClose={this.handleClose} closable={visible} fixedTags={fixedTags} />
                    }
                    {category === ac.WEIGHT &&
                        <span>{tags[0]} kg ~ {tags[1]} kg</span>
                    }
                </div>
            </>
        );
    }
}

EditableTagGroup.propTypes = {
    id: PropTypes.string,
    category: PropTypes.string,
    categoryName: PropTypes.string,
    data: PropTypes.array,
    fixedTags: PropTypes.array,

    visible: PropTypes.bool,
    onLeaveEdit: PropTypes.func,
    onEnterEdit: PropTypes.func,

    inputProps: PropTypes.object,
};

export default EditableTagGroup;